<template>
  <ion-card class="py-2 survey-card">
    <div class="page-header">
      <div class="title-header">
        <span class="mb-2">{{ titlePrefix }}</span>
        <span class="font-bold">{{ title }}</span>
      </div>
      <div class="title-details">
        <div
          class="w-full flex justify-content-end align-items-center text-14 mb-2"
          style="color: #656979; text-align: end"
        >
          <IonIcon class="mr-2" :icon="calendarClear" />
          <span>{{ surveyDurationText }}</span>
        </div>
        <span class="text-14">{{
          new Date(surveyDuration).toLocaleDateString("it", {
            year: "2-digit",
            month: "2-digit",
            day: "2-digit",
          })
        }}</span>
      </div>
    </div>

    <div class="separator"></div>

    <div class="page-container">
      <div class="user-avatars-container">
        <UserCard
          v-for="user in users"
          :key="user.name"
          :user="user"
          v-model="user.selected"
          :disabled="true"
          @click="goToSurvey(user)"
        />
      </div>
    </div>
  </ion-card>
</template>

<script setup>
import { defineProps } from "vue";
import UserCard from "./UserCard.vue";
import { useRouter } from "vue-router";
import { useGeneralStore } from "@/stores/useGeneralStore";
import { usePkSurvey } from "@/stores/usePkSurvey";

const generalStore = useGeneralStore();
const pkSurvey = usePkSurvey();
const router = useRouter();

// Props
const props = defineProps({
  titlePrefix: {
    type: String,
    default: null,
  },
  title: {
    type: String,
    default: 'Survey',
  },
  surveyDurationText: {
    type: String,
    default: "Survey duration",
  },
  surveyDuration: {
    type: String,
    default: "",
  },
  users: {
    type: Array,
    required: true,
  },
});

// Methods
const goToSurvey = (user) => {
  pkSurvey.setCurrentUser(user);
  generalStore.setCurrentSurvey({ ...user });
  router.push("/pk-survey/124");
};
</script>

<style scoped>
.survey-card {
  //background: var(--folder-bg-color) !important;
  background: black !important;
}
.title-header {
  display: flex;
  flex-direction: column;
  padding: 0 20px;
}

.title-details {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  justify-content: flex-end;
}

.separator {
  height: 1px;
  width: 100%;
  background-color: #525252;
}

.font-bold {
  margin-bottom: 1.8rem;
}

.page-container {
  padding: 16px 16px 0;
}

.page-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px;
  position: relative;
  z-index: 1;
}

.card {
  border-radius: 10px;
  background-color: var(--ion-color-primary);
  padding: 20px 0;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  z-index: 2;
  position: relative;
  min-height: 100px;
}


.user-avatars-container {
  display: flex;
  overflow-x: auto;
  gap: 10px;
  padding: 10px 0;
  max-width: 100%;
  width: 100%;
  flex-wrap: nowrap;
}

.user-avatars-container::-webkit-scrollbar {
  height: 8px;
  display: none;
}

.user-avatars-container::-webkit-scrollbar-thumb {
  background-color: #888;
  border-radius: 10px;
}

.user-avatars-container::-webkit-scrollbar-track {
  background-color: #f1f1f1;
}
.user-card {
  flex: 0 0 auto; 
}
</style>
